// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__uExdn","head":"ProcedureTableInfo_head__35U3O"};